import "core-js/modules/es6.number.constructor";
//
//
//
//
import echarts from 'echarts';
import { on, off } from '@/libs/tools';
export default {
  name: 'ChartBar',
  props: {
    soc: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      dom: null,
      chartOption: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    updateChart: function updateChart() {
      if (this.dom) {
        this.dom.setOption({
          series: [{
            data: [{
              value: this.soc,
              name: 'soc'
            }],
            axisLine: {
              lineStyle: {
                color: [[this.soc / 100, '#2D8CF0'], [1, '#E1E6EA']]
              }
            }
          }]
        });
      }
    },
    initChart: function initChart() {
      this.chartOption = {
        series: [{
          name: 'soc',
          type: 'gauge',
          axisLine: {
            show: true,
            lineStyle: {
              width: 10,
              opacity: 0,
              color: [[this.soc / 100, '#2D8CF0'], [1, '#E1E6EA']]
            }
          },
          pointer: {
            itemStyle: {
              color: 'red'
            },
            show: false
          },
          axisTick: {
            distance: 0,
            length: 14,
            splitNumber: 5,
            lineStyle: {
              color: 'auto',
              width: 1
            }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: {
              color: 'red',
              width: 4
            },
            show: false
          },
          axisLabel: {
            color: 'red',
            distance: 40,
            fontSize: 20,
            show: false
          },
          detail: {
            valueAnimation: true,
            formatter: '{value} %',
            color: '#2D8CF0',
            fontSize: 24,
            offsetCenter: [0, '10%'],
            height: 200
          },
          title: {
            offsetCenter: [0, '90%'],
            fontSize: 14,
            color: '#353739'
          },
          data: [{
            value: this.soc,
            name: 'soc'
          }]
        }]
      };
      this.dom = echarts.init(this.$refs.dom);
      this.dom.setOption(this.chartOption);
    }
  },
  mounted: function mounted() {
    this.initChart();
    on(window, 'resize', this.resize);
  },
  watch: {
    soc: function soc(newVal) {
      this.updateChart(); // 更新图表数据
    }
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};